import { render, staticRenderFns } from "./AdminNav.vue?vue&type=template&id=2b7a76a3&"
import script from "./AdminNav.vue?vue&type=script&lang=ts&"
export * from "./AdminNav.vue?vue&type=script&lang=ts&"
import style0 from "./AdminNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports